import Tabs from '@cloudscape-design/components/tabs';
import { OrderTypes } from '@parallel-fluidics/shared/constants';
import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import CustomerProjectsList from './customerProjectsList';
import InternalProjectsList from './internalProjectsList';

export default function ProjectsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTabId, setActiveTabId] = useState(searchParams.get('type') || OrderTypes.CUSTOMER);

  return (
    <Tabs
      activeTabId={activeTabId}
      onChange={({ detail }) => {
        setActiveTabId(detail.activeTabId);
        setSearchParams({ type: detail.activeTabId });
      }}
      tabs={[
        {
          label: 'Customer Projects',
          id: OrderTypes.CUSTOMER,
          content: <CustomerProjectsList />,
        },
        {
          label: 'Internal Projects',
          id: OrderTypes.INTERNAL,
          content: <InternalProjectsList />,
        },
      ]}
    />
  );
}
